import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { ExpertCalibration_Interface } from 'src/app/Interface/ExpertCalibration_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';
import { ExpertCalibrationService } from 'src/app/Service/ExpertCalibration/ExpertCalibration.service';
import { GeneralService } from 'src/app/Service/General/General.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-DeviceBehfaDownloadUpload',
  templateUrl: './DeviceBehfaDownloadUpload.component.html',
  styleUrls: ['./DeviceBehfaDownloadUpload.component.scss']
})
export class DeviceBehfaDownloadUploadComponent implements OnInit {

  Token: string = ""
  Fullname: String = ""
  nowDate: String = ""
  Check_Message:boolean=false
  Filter_Type_Lap: String = '1'
  Filter_Code: String = ''
  ExpertCalibration: String = ''

  QRCodeInput: String = ""
  QRCodeInput_Controller: number = 0
  DowloadType: String = "1"
  page: number = 0;
  Procssing: boolean = false;
  InProccessing: boolean = false;

  modalRef_Upload: any;

  DataList_DeviceBehfa: Array<DeviceBehfa_Interface> = []
  constructor(
    private DeviceBehfa_Service: DeviceBehfaService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private General_Service: GeneralService,

    private modalService: BsModalService
  ) { }


  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token, 51).subscribe(
      data => {
        this.Fullname=localStorage.getItem('Daro_User_Fullname');
        this.General_Service.GetFullDate(this.Token).subscribe(
          data=>{

            this.nowDate=data['fulldate']
          }
        )
        //this.ReadData_DeviceBehfa()
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )


  }




  ReadData_DeviceBehfa(StartSearchDate, EndSearchDate) {
    this.Procssing = true

    this.DeviceBehfa_Service.GetRecordDowloadUpload(this.Token,
      StartSearchDate,
      EndSearchDate,
      this.ExpertCalibration,
      this.Filter_Code,
      Number(this.Filter_Type_Lap)).subscribe(
      data => {
        this.DataList_DeviceBehfa = data
        this.Procssing = false

      }, error => {
        localStorage.clear()
        location.reload();
      }
    )

  }


  OnGet_ExpertCalibration_Action(model: Array<ExpertCalibration_Interface>)
  {
    this.ExpertCalibration = "-1"
    for (let item of model)
    {
      this.ExpertCalibration=this.ExpertCalibration+","+item.id
    }

    if (model.length == 0)
      this.ExpertCalibration=""

  }



  //#region Upload

  openModalUpload(template: TemplateRef<any>) {
    this.modalRef_Upload = this.modalService.show(template);
    this.QRCodeInput = ""
    this.QRCodeInput_Controller = 2
    setInterval(() => {
      this.Info_Upload()

    }, 1000);
  }

  Info_Upload_Proccesing: boolean = false
  Info_Upload_List: Array<DeviceBehfa_Interface> = []
  Info_Upload() {

    if (!this.Info_Upload_Proccesing && this.QRCodeInput && this.QRCodeInput_Controller == 2) {
      this.Info_Upload_Proccesing = true
      this.DeviceBehfa_Service.GetInfobyQR(this.Token, this.QRCodeInput).subscribe(
        data => {


          this.Info_Upload_Proccesing = false



          this.QRCodeInput = ""
        }, error => {
          this.Info_Upload_Proccesing = false
          this.Alertify_Service.ErrorMessage("The scanned QR code is invalid.")
          this.QRCodeInput = ""
        }
      )
    }
  }

  Info_Upload_Remove(id: number) {
    this.Info_Upload_List.splice(id, 1)
    this.Alertify_Service.SuccessMessage("Deleted successfully.")
  }

  Info_Upload_Exist(input: DeviceBehfa_Interface) {
    for (let item of this.Info_Upload_List) {
      if (item.id == input.id) {
        return true
      }
    }
    return false
  }

  QRCodeChangeUpload() {

    var Code: Array<String> = []
    for (let item of this.Info_Upload_List) {
      Code.push(item.model)
    }

    this.InProccessing = true
    this.DeviceBehfa_Service.PostUpload(Code, this.Token).subscribe(
      data => {

        this.InProccessing = false
        this.QRCodeInput = ""
        this.Info_Upload_List = []

        for (let item of this.Info_Upload_List) {
          if (item.id == 0) {
            this.Alertify_Service.ErrorMessage(item.username)
          }
          else {
            this.Alertify_Service.SuccessMessage("Saved successfully.")
            //this.ReadData_DeviceBehfa()
          }
        }

      }, error => {
        localStorage.clear()
        location.reload();

      }
    )


  }


  //#endregion









}
